import { useState } from "react";
import { useStyles } from "hooks/hooks";
import { Menu, Divider } from "@mui/material";
import CheckableMenuItem from "./CheckableMenuItem";
import TableItemsMenu from "./TableItemsMenu";
import styles from "../DataGridTable.module.scss";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "hooks/UseTranslations";
// import { clearTableFilter } from "actions/dashboard/dashboard";
interface TableNameItemsInterface {
    id: number;
    label: string;
    link: string;
}
interface Props {
    tableName: string;
    tableNameItems?: Array<TableNameItemsInterface>;
    handleSearch: any;
    filterOptions: Array<string>;
    columnsPerPage?: number;
    setPageColumn?: Function;
    setOrder?: Function;
    order?: string;
    placeholder: string;
    seeHistoryLink?: string;
    statuses?: Array<string>;
    setStatus?: Function;
    status?: string;
}

export default function DataGridFilters({
    tableName,
    tableNameItems,
    filterOptions,
    handleSearch,
    setPageColumn,
    columnsPerPage,
    setOrder,
    order,
    placeholder,
    seeHistoryLink,
    statuses,
    setStatus,
    status
}: Props) {
    const classes = useStyles({
        popupMenu: {
            maxHeight: "350px !important",
            "& .MuiMenu-paper": {
                marginTop: "5px",
                boxShadow: "0px 8px 18px #1A284D1A !important",
                border: "1px solid #EBECF2 !important",
                borderRadius: "5px !important"
            }
        },
        menuItem: {
            width: "204px",
            height: "40px"
        },
        menuTitle: {
            fontFamily: "PolySans Median",
            fontSize: "13px",
            fontWeight: "600",
            marginLeft: "15px"
        }
    });

    const navigate = useNavigate();
    const [filtersAnchorEl, setFiltersAnchorEl] = useState<null | HTMLElement>(null);
    const [showSearchBtn, setShowSearchBtn] = useState<boolean>(false);
    const { translations } = useTranslations();
    const defaultFilters = [
        {
            filterName: `${translations("filter.show")}`,
            value: "show",
            filters: [
                {
                    display: `${"5 " + translations("label.column_rows")}`,
                    checked: 5 === columnsPerPage,
                    value: 5,
                    onClick: () => {
                        setPageColumn(5);
                    }
                },
                {
                    display: `${"10 " + translations("label.column_rows")}`,
                    checked: 10 === columnsPerPage,
                    value: 10,
                    onClick: () => {
                        setPageColumn(10);
                    }
                },
                {
                    display: `${"15 " + translations("label.column_rows")}`,
                    checked: 15 === columnsPerPage,
                    value: 15,
                    onClick: () => {
                        setPageColumn(15);
                    }
                }
            ]
        },
        {
            filterName: `${translations("checkout.order")}`,
            value: "order",
            filters: [
                {
                    display: `${translations("filter.oldest")}`,
                    checked: "desc" === order,
                    onClick: () => {
                        setOrder("desc");
                    }
                },
                {
                    display: `${translations("filter.newest")}`,
                    checked: "asc" === order,
                    onClick: () => {
                        setOrder("asc");
                    }
                }
            ]
        },
        {
            filterName: `${translations("title.status")}`,
            value: "status",
            filters:
                statuses?.map((el) => {
                    return {
                        display: el,
                        value: el,
                        checked: el === status,
                        onClick: () => {
                            setStatus(el);
                        }
                    };
                }) || []
        },
        {
            filterName: `${translations("products.categories")}`,
            value: "categories",
            filters:
                statuses?.map((el) => {
                    return {
                        display: el,
                        value: el,
                        checked: el === status,
                        onClick: () => {
                            setStatus(el);
                        }
                    };
                }) || []
        }
    ];

    const popupMenu = () => {
        let openMenu = Boolean(filtersAnchorEl);

        return (
            <Menu
                anchorEl={filtersAnchorEl}
                open={openMenu}
                onClose={() => setFiltersAnchorEl(null)}
                className={classes.popupMenu}>
                {defaultFilters
                    .filter((el) => filterOptions.includes(el.value))
                    .map((el, idx) => {
                        return (
                            <div key={idx}>
                                <p className={classes.menuTitle}>{el.filterName}</p>
                                {el.filters.map((filter, idx) => (
                                    <CheckableMenuItem
                                        key={idx}
                                        filter={filter}
                                        checked={filter.checked}
                                        onClick={() => {
                                            setFiltersAnchorEl(null);
                                            filter.onClick();
                                        }}
                                    />
                                ))}
                                <Divider />
                            </div>
                        );
                    })}
            </Menu>
        );
    };

    return (
        <div className={styles.dataGridFilters}>
            {tableName && !tableNameItems && (
                <p className={showSearchBtn ? `${styles.tableName} ${styles.deActive}` : styles.tableName}>
                    {tableName}
                </p>
            )}
            {tableNameItems ? <TableItemsMenu tableNameItems={tableNameItems} showSearchBtn={showSearchBtn} /> : null}
            <div className={styles.filtersWrap}>
                <div className={showSearchBtn ? "search-input" : "search-input hidden"}>
                    <i className="arrow-icon"></i>
                    <input type="text" placeholder={placeholder} onChange={handleSearch}></input>
                </div>
                {!seeHistoryLink ? (
                    <>
                        <button className={styles["btn-search"]} onClick={(e) => setShowSearchBtn((prev) => !prev)}>
                            <i className={styles["search-icon"]}></i>
                        </button>
                        <button className={styles["btn-filter"]} onClick={(e) => setFiltersAnchorEl(e.currentTarget)}>
                            <i className={styles["filters-icon"]}></i>
                        </button>
                    </>
                ) : (
                    <div onClick={() => navigate(`/web/${seeHistoryLink}`)} style={{ cursor: "pointer" }}>
                        {translations("action.see_history")}
                    </div>
                )}
            </div>
            {popupMenu()}
        </div>
    );
}
